// File: TocList.js
import React, { useEffect, useState } from 'react';
import { List, ListItem, ListItemText } from '@mui/material';
import { TocItem } from './TocItem';
import { SIDENAV_MODES } from "../SideNavigation";

const maxInitialItems = 50;

/**
 * Reveals more siblings when the active article lies outside the visible slice.
 */
const TocList = ({
    items,
    level = 0,
    defaultOpenLevels,
    onArticleSelect,
    selectedArticleId,
    activePath,
    mode,
    selectedIds,
    toggleSelect,
    autoScrollEnabled,
}) => {
    const [visibleCount, setVisibleCount] = useState(maxInitialItems);
    const visibleItems = items.slice(0, visibleCount);

    const handleLoadMore = () => setVisibleCount(prev => prev + maxInitialItems);

    useEffect(() => {
        const activeIdAtLevel = activePath[level];
        if (!activeIdAtLevel) return;

        const activeIndex = items.findIndex(item => item._id === activeIdAtLevel);
        if (activeIndex === -1 || activeIndex < visibleCount) return;

        setVisibleCount(prev => Math.max(prev, activeIndex + 1));
    }, [activePath, items, level, visibleCount]);

    return (
        <List component="div" disablePadding>
            {visibleItems.map(item => (
                <TocItem
                    key={item._id}
                    item={item}
                    level={level}
                    defaultOpenLevels={defaultOpenLevels}
                    onArticleSelect={onArticleSelect}
                    selectedArticleId={selectedArticleId}
                    activePath={activePath}
                    mode={mode}
                    selectedIds={selectedIds}
                    toggleSelect={toggleSelect}
                    TocList={TocList}
                    autoScrollEnabled={autoScrollEnabled}
                />
            ))}
            {(mode === SIDENAV_MODES.none) && visibleCount < items.length && (
                <ListItem button onClick={handleLoadMore} sx={{ pl: 2 * level }}>
                    <ListItemText primary="Load more…" />
                </ListItem>
            )}
        </List>
    );
};

export default TocList;
